/* eslint-disable */
import {SETUSER, SETUSEROUT, SETARTWORKS, SERVER} from "./actionType";
import axios from "axios";

export const loading = (loading) => {
  return {
    type: "LOADING_USER",
    loading,
  };
};

export const logout = () => {
  return {
    type: SETUSEROUT,
  };
};
export const login = (data) => {
  return (dispatch) => {
    //console.log(data);

    axios
      .post(SERVER + "/auth/local", data)
      .then(function (response) {
        //console.log(resp);
        dispatch({type: SETUSER, data: response.data});
      })
      .catch((error) => {
        console.log(error);

        throw error;
      });
  };
};

export const register = (data) => {
  return (dispatch) => {
    //console.log(data);

    axios
      .post(SERVER + `/auth/local/register`, data)
      .then(function (response) {
        dispatch(login({identifier: data.email, password: data.password}));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const addArtwork = (data, token) => {
  return (dispatch) => {
    //console.log(data);

    axios
      .post(SERVER + `/artworks`, data)
      .then(function (response) {
        dispatch(getDataUser(data.users[0], token));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getDataUser = (id, token) => {
  return (dispatch) => {
    //console.log(data);

    axios
      .get(SERVER + "/users?_id=" + id)
      .then(function (response) {
        //console.log(resp);
        if (response && response.data && response.data.length > 0) {
          let rep = {};
          rep.user = response.data[0];
          rep.jwt = token;

          dispatch({type: SETUSER, data: rep});
        }
      })
      .catch((error) => {
        console.log(error);

        throw error;
      });
  };
};

export const listArtworks = () => {
  return (dispatch) => {
    axios
      .get(`${SERVER}/artworks`)
      .then(function (response) {
        dispatch({type: SETARTWORKS, data: response.data});
      })
      .catch(function (error) {
        console.log(error);
      });
    //console.log(data);
  };
};
